const REGION_LABELS = {
  us: 'US',
  eu: 'EU',
  asia: 'Asia',
} as const;

type RegionKey = keyof typeof REGION_LABELS;

export const REGION =
  REGION_LABELS[import.meta.env.VITE_REGION as RegionKey] ?? null;

const selectorBase = import.meta.env.VITE_REGION_SELECTOR_URL ?? '';

export const REGION_SELECTOR_URL = selectorBase
  ? `${selectorBase.replace(/\/$/, '')}/?reset=1`
  : null;
